(() => {
  if (window.__productCardCustomBadgesInitialized === true) {
    return;
  }

  window.__productCardCustomBadgesInitialized = true;

  const ROOT_SELECTOR = '[data-product-card-badges]';
  const BADGE_SELECTOR = '[data-product-card-badge]';

  function isHTMLElement(value) {
    return value instanceof HTMLElement;
  }

  function getDatasetNumber(element, key) {
    const value = Number(element.dataset[key] || 0);

    return Number.isFinite(value) ? value : 0;
  }

  function getBadgeTimeState(badge, currentTimestamp) {
    const startTimestamp = getDatasetNumber(badge, 'startTs');
    const endTimestamp = getDatasetNumber(badge, 'endTs');

    const isBeforeStart =
      startTimestamp > 0 && currentTimestamp < startTimestamp;
    const isExpired =
      endTimestamp > 0 && currentTimestamp >= endTimestamp;

    let nextTransitionTimestamp = null;

    if (isBeforeStart) {
      nextTransitionTimestamp = startTimestamp;
    } else if (!isExpired && endTimestamp > currentTimestamp) {
      nextTransitionTimestamp = endTimestamp;
    }

    return {
      isActive: !isBeforeStart && !isExpired,
      nextTransitionTimestamp,
    };
  }

  function setBadgeVisibility(badge, isVisible) {
    badge.hidden = !isVisible;
    badge.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  }

  function synchronizeBadges(root) {
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const badges = Array.from(
      root.querySelectorAll(BADGE_SELECTOR)
    ).filter(isHTMLElement);

    let visibleBadgeCount = 0;
    let nextTransitionTimestamp = null;

    badges.forEach((badge) => {
      const state = getBadgeTimeState(badge, currentTimestamp);

      setBadgeVisibility(badge, state.isActive);

      if (state.isActive) {
        visibleBadgeCount += 1;
      }

      if (state.nextTransitionTimestamp !== null) {
        nextTransitionTimestamp =
          nextTransitionTimestamp === null
            ? state.nextTransitionTimestamp
            : Math.min(
                nextTransitionTimestamp,
                state.nextTransitionTimestamp
              );
      }
    });

    const hasVisibleBadges = visibleBadgeCount > 0;

    root.hidden = !hasVisibleBadges;
    root.setAttribute(
      'aria-hidden',
      hasVisibleBadges ? 'false' : 'true'
    );

    return nextTransitionTimestamp;
  }

  function initializeRoot(root) {
    if (
      root.dataset.productCardBadgesInitialized === 'true'
    ) {
      return;
    }

    root.dataset.productCardBadgesInitialized = 'true';

    let timeoutId = null;

    const update = () => {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
        timeoutId = null;
      }

      const nextTransitionTimestamp = synchronizeBadges(root);

      if (nextTransitionTimestamp === null) {
        return;
      }

      const currentTimestamp = Math.floor(Date.now() / 1000);
      const delay = Math.max(
        (nextTransitionTimestamp - currentTimestamp) * 1000 + 100,
        1000
      );

      timeoutId = window.setTimeout(update, delay);
    };

    update();
  }

  function initializeBadges(scope = document) {
    if (
      scope instanceof HTMLElement &&
      scope.matches(ROOT_SELECTOR)
    ) {
      initializeRoot(scope);
    }

    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (isHTMLElement(root)) {
        initializeRoot(root);
      }
    });
  }

  initializeBadges();

  document.addEventListener('DOMContentLoaded', () => {
    initializeBadges();
  });

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;

    if (target instanceof Element) {
      initializeBadges(target);
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          initializeBadges(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

